<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'SETTINGS_UNITS' }
  ]"
></breadcrumbs>

<page-header title="SETTINGS_UNITS"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_UNITS_AREA_NAME"
        >{{ 'SETTINGS_UNITS_AREA_NAME' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SETTINGS_UNITS_AREA_NAME"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_UNITS_AREA_NAME'])"
          [ngClass]="{ 'is-danger': hasError('SETTINGS_UNITS_AREA_NAME') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_UNITS_AREA_NAME')">
        {{ getError('SETTINGS_UNITS_AREA_NAME') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_UNITS_AREA_SYMBOL"
        >{{ 'SETTINGS_UNITS_AREA_SYMBOL' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SETTINGS_UNITS_AREA_SYMBOL"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_UNITS_AREA_SYMBOL'])"
          [ngClass]="{ 'is-danger': hasError('SETTINGS_UNITS_AREA_SYMBOL') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_UNITS_AREA_SYMBOL')">
        {{ getError('SETTINGS_UNITS_AREA_SYMBOL') }}
      </p>
    </div>

    <div class="formula">
      <div>
        1 m² =
        <number-input
          name="SETTINGS_UNITS_AREA_TO_METERS"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_UNITS_AREA_TO_METERS'])"
          [inputClass]="{
            'input is-small': true,
            'is-danger': hasError('SETTINGS_UNITS_AREA_TO_METERS')
          }"
        />
        {{ getField(['SETTINGS_UNITS_AREA_SYMBOL']) }}
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_UNITS_AREA_TO_METERS')"
      >
        {{ getError('SETTINGS_UNITS_AREA_TO_METERS') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="AREA_ROUNDING">{{
        'AREA_ROUNDING' | translate
      }}</label>
      <div class="control">
        <ng-select
          [items]="areaRoundingOptions"
          [multiple]="false"
          [closeOnSelect]="true"
          (change)="
            handleFieldChange($event?.value, 'SETTINGS_UNITS_AREA_ROUNDING')
          "
          [ngClass]="{
            'is-danger': hasError('SETTINGS_UNITS_AREA_ROUNDING')
          }"
          bindLabel="text"
          bindValue="value"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField(['SETTINGS_UNITS_AREA_ROUNDING'])"
          class="is-small"
        >
        </ng-select>
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_UNITS_AREA_ROUNDING')"
      >
        {{ getError('SETTINGS_UNITS_AREA_ROUNDING') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_UNITS_CURRENCY_NAME"
        >{{ 'SETTINGS_UNITS_CURRENCY_NAME' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SETTINGS_UNITS_CURRENCY_NAME"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_UNITS_CURRENCY_NAME'])"
          [ngClass]="{
            'is-danger': hasError('SETTINGS_UNITS_CURRENCY_NAME')
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_UNITS_CURRENCY_NAME')"
      >
        {{ getError('SETTINGS_UNITS_CURRENCY_NAME') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="SETTINGS_UNITS_CURRENCY_SYMBOL"
        >{{ 'SETTINGS_UNITS_CURRENCY_SYMBOL' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          name="SETTINGS_UNITS_CURRENCY_SYMBOL"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SETTINGS_UNITS_CURRENCY_SYMBOL'])"
          [ngClass]="{
            'is-danger': hasError('SETTINGS_UNITS_CURRENCY_SYMBOL')
          }"
        />
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_UNITS_CURRENCY_SYMBOL')"
      >
        {{ getError('SETTINGS_UNITS_CURRENCY_SYMBOL') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
